import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  changeUserRole,
  getElementsByUserId,
  selectedUserList,
} from "../../actions/admin";
import { formatMobileNumber, showRole } from "../../utils/comman";
import { Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import DataTable from "../../components/Comman/CustomTable/CommonTable";
import defaultProfile from "../../assets/img/profile-icon.svg";
import ChangeUserRoleModel from "../../components/Comman/ChangeUserRoleModel/ChangeUserRoleModel";

const ViewUser = () => {
  const location = useParams();
  const dispatch = useDispatch<any>();
  const user = useSelector((state: any) => state?.Auth?.user);
  const roleId = user?.user?.roleId;
  const [loading, setLoading] = useState<boolean>(true);
  const [userData, setUserData] = useState<any>();
  const [userId, setUserId] = useState(null);
  const [dataElements, setDataElements] = useState<any>([]);
  const [openModel, setOpenModel] = useState<boolean>(false);
  const [orgId, setOrgId] = useState<string>(null);
  const [userRoleId, setUserRoleId] = useState<string>(null); // the user's unique role id
  const [accessRoleId, setAccessRoleId] = useState(null); // the user's type role id
  const [sortConfig, setSortConfig] = useState<{
    field: string | null;
    order: "asc" | "desc" | null;
  }>({
    field: null,
    order: null,
  });
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const getUserData = () => {
    setLoading(true);
    dispatch(
      selectedUserList(location?.id, (resp: any) => {
        setLoading(false);
        if (resp?.status === 200 || resp?.status === 201) {
          setUserData(resp?.data || []);
          setAccessRoleId(resp?.data?.roleId);
          setUserId(resp?.data?.id);
        }
      })
    );
  };

  useEffect(() => {
    getUserData();
  }, [userId]);

  const getElementsAssigned = (params = {}) => {
    setLoading(true);
    const data = {
      params,
      userId,
    };
    dispatch(
      getElementsByUserId(data, (resp: any) => {
        setLoading(false);
        if (resp?.status === 200 || resp?.status === 201) {
          setDataElements(resp?.data || []);
          setPagination({
            ...pagination,
            total: resp.pagination?.totalItems,
            current: resp.pagination?.currentPage,
            pageSize: resp.pagination?.pageSize,
          });
        }
      })
    );
  };

  useEffect(() => {
    if (userId)
      getElementsAssigned({
        page: pagination.current || 1,
        limit: pagination.pageSize || 10,
      });
  }, [userId]);

  const handleTableChange = (pagination: any, filters: any, sorter: any) => {
    let newSortConfig = { ...sortConfig };
    if (sorter && Object.keys(sorter).length > 0) {
      newSortConfig = {
        field: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      };
    }
    setSortConfig(newSortConfig);
    getElementsAssigned({
      page: pagination.current || 1,
      limit: pagination.pageSize || 10,
      ...(newSortConfig.field && newSortConfig.order
        ? {
            sort: newSortConfig.field,
            order: newSortConfig.order,
          }
        : {}),
    });
  };

  const handelRoleModel = () => {
    setOpenModel(!openModel);
  };

  const handleModelFunction = () => {
    dispatch(
      changeUserRole(
        {
          roleId: userRoleId,
          userId: location.id,
          organizationId: orgId,
        },
        (resp: any) => {
          if (resp?.status === 200 || resp?.status === 201) {
            setOpenModel(!openModel);
            getUserData();
          }
        }
      )
    );
  };

  const columns = [
    {
      title: "Org",
      dataIndex: "organizationName",
      key: "organizationName",
      render: (_: any, record: any) =>
        record?.orgElementsLinks?.[0]?.organization?.shortCode || "-",
    },
    {
      title: "Element Name",
      dataIndex: "DataElements_Name",
      key: "DataElements_Name",
      // sorter: true,
    },
    {
      title: "Description",
      dataIndex: "DataElements_Description",
      key: "DataElements_Description",
    },
    {
      title: "Element Type",
      dataIndex: "DataElements_DataType",
      key: "DataElements_DataType",
    },

    {
      title: `Is Budgeted`,
      dataIndex: "DataElements_IsBudgeted",
      key: "DataElements_IsBudgeted",
      render: (data) => (data === true ? "Yes" : "No"),
    },
    {
      title: `Is Roll Up`,
      dataIndex: "DataElements_IsRollUp",
      key: "DataElements_IsRollUp",
      render: (data) => (data === true ? "Yes" : "No"),
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "categoryId",
      render: (data) => data?.name || "-",
      // sorter: true,
    },
  ];

  return (
    <div>
      {/* <Header /> */}
      <div className="flex gap-[20px] mt-[20px] flex-wrap">
        <div className="flex brand-details-wrapper p-[10px] gap-[60px]  2xl:gap-[100px] rounded-[10px] bg-primary size-full flex-col md:flex-row justify-center sm:justify-start">
          <div className="rounded-[8px] overflow-hidden border border-[#282828]">
            {/* <img
              src={<Avatar size={64} icon={<UserOutlined />} />}
              alt="User-profile-image"
              className="p-[3px] h-[200px] w-[200px]  bg-primary rounded-[10px] object-cover "
            /> */}
            <Avatar
              size={200}
              src={
                userData?.profilePhoto ? userData?.profilePhoto : defaultProfile
              } // Dynamically set image
              icon={!userData?.profilePhoto && <UserOutlined />} // Show icon if no image
              className="p-[3px] bg-primary rounded-[10px] object-cover"
            />
          </div>

          <div className="text-center sm:text-start  w-full sm:w-[calc(100%-30px)] md:w-1/3">
            <h3 className="mb-[10px]"></h3>

            <p className="info-col"></p>

            <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
              <p className="info-col min-w-[65px]">Name : </p>
              <p>{userData?.name ? userData?.name : "-"}</p>
            </div>

            <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
              <p className="info-col">Mobile Number : </p>
              <p>
                {userData?.mobileNumber
                  ? formatMobileNumber(userData?.mobileNumber)
                  : "-"}
              </p>
            </div>

            <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
              <p className="info-col">Email : </p>
              <p>{userData?.email ? userData?.email : "-"}</p>
            </div>

            <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
              <p className="info-col">Role : </p>
              <p>{showRole[userData?.roleId]}</p>
            </div>
            {userData?.address && (
              <div className="d-flex gap-1 my-[10px] text-[12px] 2xl:text-[sm] justify-center sm:justify-start">
                <p className="info-col">Address : </p>
                <p>{userData?.address}</p>
              </div>
            )}
          </div>

          <div className="flex flex-col text-center sm:text-start w-full sm:w-[calc(50%-30px)] md:w-1/3">
            <p className="mt-[7px]">Organization Name : </p>

            {userData?.organizationAssignment?.map((data, index) => (
              <p className="info-col my-1" key={index}>
                {data?.organization?.name}
              </p>
            ))}

            {roleId === 1 && accessRoleId !== 1 && (
              <div className="flex justify-between mt-3">
                <button
                  className="update-role-btn"
                  onClick={
                    () => handelRoleModel()
                    // assignment?.user?.role === "Leader" ? 2 : 3
                  }
                >
                  Update Role
                  {/* {assignment?.user?.role === "Leader"
                            ? "Leader"
                            : "Controller"} */}
                </button>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="mt-5">
        {/* <Header /> */}
        <h1 className="text-3xl font-bold text-left mb-6 text-white">
          Data Elements
        </h1>
        <div className="table-col">
          <DataTable
            columns={columns}
            data={dataElements}
            loading={loading}
            rowKey="id"
            pagination={{
              current: pagination.current,
              pageSize: pagination.pageSize,
              total: pagination.total,
            }}
            onTableChange={handleTableChange}
          />
        </div>
      </div>

      {openModel && (
        <ChangeUserRoleModel
          handleConfirmRoleModel={() => handelRoleModel()}
          handleModelFunction={handleModelFunction}
          userId={location?.id}
          setUserRoleId={setUserRoleId}
          setOrgId={setOrgId}
          accessRoleId={accessRoleId}
        />
      )}
    </div>
  );
};

export default ViewUser;
